import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import "./styles.css";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import { GoHighLevelAPI } from "../../../redux/slices/SendEmail";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

const cookies = new Cookies();

const SubmitEmailModal = ({ isOpen, onClose }) => {

  const location = useLocation();
  const pageSlug = location.pathname
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [file, setFile] = useState(null);
  const [modalWidth, setModalWidth] = useState("50%");

  useEffect(() => {
    const updateWidth = () => {
      if (window.innerWidth <= 768) {
        setModalWidth("90%");
      } else if (window.innerWidth <= 1024) {
        setModalWidth("50%");
      } else {
        setModalWidth("50%");
      }
    };

    updateWidth(); // Set initial value
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const handleOnChange = (e) => {
    setEmail(e.target.value);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      if (selectedFile.size > 5 * 1024 * 1024) {
        toast.error("File size must be less than 5MB");
        e.target.value = ""; // reset input
        setFile(null);
      } else {
        setFile(selectedFile);
        console.log("Selected File:", selectedFile);
      }
    }
  };


  const sheetName = "EmailSubmissions";

  const state = {
    Email: email,
    SheetName: sheetName,
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent the default form submission behavior

    if (email === "") {
      toast.error("Please enter the email");
    } else {
      setIsLoading(true);
      const formData = new FormData();
      for (const key in state) {
        if (state.hasOwnProperty(key)) {
          const value = state[key];

          if (Array.isArray(value)) {
            for (let i = 0; i < value.length; i++) {
              formData.append(`${key}[${i}]`, value[i]);
            }
          } else {
            formData.append(key, value);
          }
        }
      }

      fetch(
        process.env.REACT_APP_GSHEET_URL,
        {
          method: "POST",
          body: formData,
          mode: "no-cors",
        }
      )
        .then((data) => {
          cookies.set("emailAccepted", "Yes", { path: "/" }); // Ensure cookie applies site-wide
          console.log(data);
          const highLevelApiObject = {
            email: email,
            tags: ["PopUp", "Filled website form", pageSlug]
          }
          const resHighLevelObjectApi = dispatch(GoHighLevelAPI(highLevelApiObject))
          console.log(resHighLevelObjectApi);
          setIsLoading(false);

          onClose(); // Close the modal after submission
          setEmail("");
          toast.success("Success");
        })
        .catch((error) => console.log(error));
    }
  };

  const handleCloseByBtn = () => {
    cookies.set("emailAccepted", "Yes", { path: "/" }); // Ensure cookie applies site-wide
    onClose();
  };

  const { t } = useTranslation("modalsContent");
  const cookiesObj = t("privacyPolicyModal", { returnObjects: true });

  return (
    <Popup
      open={isOpen}
      position={"center center"}
      closeOnDocumentClick={false}
      lockScroll={true}
      repositionOnResize
      contentStyle={{
        width: modalWidth,
      }}
    >
      <div className="email-modal-body-wrapper">
        <div onClick={handleCloseByBtn} className="email-custom-btn-close">
          <i className="fa-solid fa-xmark"></i>
        </div>
        <p className="text-center" style={{ color: "#80B927" }}>
          {cookiesObj.topSubHeading}
        </p>
        <h2 className="text-center mb-3 popup-heading-main">{cookiesObj.heading}</h2>
        <p className="text-center mb-4">{cookiesObj.subHeading}</p>

        <form
          className="row custom-email-modal-box justify-content-center"
          onSubmit={handleSubmit}
        >
          <div className="col-md-8">
            {/* <div className="form-floating">
              <input
                type="email"
                placeholder={cookiesObj.emailLabel}
                className="form-control border-dark"
                id="fullName"
                onChange={handleOnChange}
                value={email}
                autocomplete="off"
              />
              <label htmlFor="fullName">
                {cookiesObj.emailLabel} <span style={{ color: "red" }}>*</span>
              </label>
            </div> */}

            <div className="input-icon-boxes">
              <input
                type="email"
                placeholder={cookiesObj.emailLabel}
                className="email-input"
                id="fullName"
                onChange={handleOnChange}
                value={email}
                autocomplete="off"
              />

              <label htmlFor="uploadFile" className="upload-file-box-model">
                {file ? file.name : cookiesObj.requiredDcoument}{" "}
                <i className="fa-solid fa-cloud-arrow-up"></i>
              </label>
              <input
                id="uploadFile"
                type="file"
                className="email-input d-none"
                onChange={handleFileChange}
                autoComplete="off"
              />
            </div>

            <div className="custom-email-modal-footer">
              <div className="contact-section-button free-call-popup">
                <button type="submit" className="btn btn-primary rounded-0">
                  {isLoading ? cookiesObj.loading : cookiesObj.submitBtn}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Popup>
  );
};

export default SubmitEmailModal;
